function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) =>
/*#__PURE__*/
React.createElement("svg", _extends({
  viewBox: "0 0 23 20"
}, props),
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M11.118 4.965c.752 0 1.465.158 2.103.442l-1.9 1.899a2.646 2.646 0 00-.203-.008c-1.364 0-2.47 1.045-2.47 2.333 0 .11.007.22.023.326l-1.899 1.899a4.445 4.445 0 01-.596-2.225c0-2.578 2.212-4.666 4.942-4.666zm4.345 2.442c.38.661.596 1.419.596 2.224 0 2.579-2.211 4.667-4.941 4.667a5.168 5.168 0 01-2.103-.442l1.898-1.9c.068.006.136.009.205.009 1.363 0 2.47-1.046 2.47-2.334 0-.11-.008-.219-.024-.325l1.9-1.899zM19.25 0c-.384 0-.768.146-1.06.439L15.227 3.4a11.442 11.442 0 00-4.11-.769C5.77 2.631 2.052 6.4.446 8.406c-.593.747-.593 1.704 0 2.45.78.976 2.06 2.368 3.785 3.541l-2.305 2.306a1.5 1.5 0 002.122 2.12l2.961-2.96c1.234.471 2.608.768 4.11.768 5.348 0 9.067-3.768 10.673-5.775.593-.746.593-1.703 0-2.45-.781-.975-2.062-2.368-3.786-3.54L20.31 2.56A1.5 1.5 0 0019.25 0z"
})));